import Sidebar from "../../components/Common/Sidebar";
import { BetaTesterList } from "../../components/_pages/BetaTester";

const BetaTester = () => {
  return (
    <>
      <Sidebar />
      <BetaTesterList />
    </>
  );
};

export default BetaTester;
